<template>
  <div>
    <b-row class="row-padding">
      <b-col sm="3">
        <InputQuantity
          ref="pPIS"
          id="pPIS"
          label="% PIS"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.pPIS"
          :precision="4"
        />
      </b-col>
      <b-col sm="3">
        <SelectWithSearch
          label="CST PIS"
          placeholder="CST PIS"
          labelBusca="codigo"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.cstPis"
          ref="searchCstPIS"
          :filterBy="taxFilter"
          :change="changeCstPisSelected"
          :options="cstPISCollection"
          :search="searchCstPis"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }} - {{ props.data.descricao }}
            </div>
          </template>
          <template slot="no-options"> Selecione um CST PIS </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col sm="3">
        <InputMoney
          ref="vPIS"
          id="vPIS"
          label="Valor PIS:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :disabled="
            !hasSelectedTax(productOfPurchaseOnFiscalEdit.fiscal.values.cstPis)
          "
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vPIS"
        />
      </b-col>
      <b-col sm="3">
        <InputMoney
          ref="vBCPIS"
          id="vBCPIS"
          label="Base PIS:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :disabled="
            !hasSelectedTax(productOfPurchaseOnFiscalEdit.fiscal.values.cstPis)
          "
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vBCPIS"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding">
      <b-col sm="3">
        <InputQuantity
          ref="pCOFINS"
          id="pCOFINS"
          label="% COFINS"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.pCOFINS"
          :precision="4"
        />
      </b-col>
      <b-col sm="3">
        <SelectWithSearch
          label="CST COFINS"
          placeholder="CST COFINS"
          labelBusca="codigo"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.cstCofins"
          ref="searchCstCOFINS"
          :filterBy="taxFilter"
          :change="changeCstCofinsSelected"
          :options="cstCOFINSCollection"
          :search="searchCstCofins"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }} - {{ props.data.descricao }}
            </div>
          </template>
          <template slot="no-options"> Selecione um CST COFINS </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col sm="3">
        <InputMoney
          ref="vCOFINS"
          id="vCOFINS"
          label="Valor COFINS:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :disabled="
            !hasSelectedTax(
              productOfPurchaseOnFiscalEdit.fiscal.values.cstCofins,
            )
          "
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vCOFINS"
        />
      </b-col>
      <b-col sm="3">
        <InputMoney
          ref="vBCCOFINS"
          id="vBCCOFINS"
          label="Base COFINS:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :disabled="
            !hasSelectedTax(
              productOfPurchaseOnFiscalEdit.fiscal.values.cstCofins,
            )
          "
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vBCCOFINS"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { SelectWithSearch, InputMoney, InputQuantity } from '@/components/Form';

export default {
  name: 'PisCofinsTab',
  components: {
    SelectWithSearch,
    InputMoney,
    InputQuantity,
  },
  data() {
    return {
      taxFilter(option, search) {
        const temp = search.toLocaleLowerCase();
        return option.descricao.includes(temp) || option.codigo.includes(temp);
      },
    };
  },
  computed: {
    ...mapState('purchase', ['productOfPurchaseOnFiscalEdit']),
    ...mapState('cst', ['cstPISCollection', 'cstCOFINSCollection']),
  },
  methods: {
    ...mapActions('componentsPurchase', ['setLoadingTabPurchase']),
    ...mapActions('cst', ['setCSTPISCollection', 'setCSTCOFINSCollection']),
    hasSelectedTax(tax) {
      if (!tax || Array.isArray(tax)) {
        return false;
      }
      return true;
    },
    async searchCstPis(search) {
      if (search) {
        this.setLoadingTabPurchase(true);
        await this.setCSTPISCollection(search);
        this.setLoadingTabPurchase(false);
      }
    },
    changeCstPisSelected(selectedCstPis) {
      if (selectedCstPis) {
        this.productOfPurchaseOnFiscalEdit.fiscal.values.cstPis = {
          ...selectedCstPis,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.values.cstPis = [];
    },
    async searchCstCofins(search) {
      if (search) {
        this.setLoadingTabPurchase(true);
        await this.setCSTCOFINSCollection(search);
        this.setLoadingTabPurchase(false);
      }
    },
    changeCstCofinsSelected(selectedCstCofins) {
      if (selectedCstCofins) {
        this.productOfPurchaseOnFiscalEdit.fiscal.values.cstCofins = {
          ...selectedCstCofins,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.values.cstCofins = [];
    },
  },
};
</script>
